(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.product-sticky-buy:not([data-ready])').forEach(function (bar) {
      bar.dataset.ready = 'true';

      var sectionId = bar.dataset.sectionId;
      var form = document.getElementById('product-form-' + sectionId);
      var purchase = form && form.querySelector('.product-form__payment-container');
      var input = bar.querySelector('.product-sticky-buy__quantity input');
      var originalQty = form && form.querySelector('input[name="quantity"]');
      var buy = bar.querySelector('[data-sticky-buy]');
      var image = bar.querySelector('.product-sticky-buy__image');
      var variantText = bar.querySelector('.product-sticky-buy__variant');
      var price = bar.querySelector('.product-sticky-buy__price strong');
      var json = bar.querySelector('[data-sticky-product-json]');
      var product = json ? JSON.parse(json.textContent) : null;
      var mobileQuery = window.matchMedia('(max-width: 700px)');
      var lastY = window.scrollY;
      var directionStartY = lastY;
      var lastDirection = '';
      var isVisible = false;

      function money(cents) {
        if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, window.theme && theme.moneyFormat);
        return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      }

      function quantity(value) {
        value = Math.max(1, parseInt(value, 10) || 1);
        input.value = value;
        if (originalQty) originalQty.value = value;
      }

      function currentVariantId() {
        var selector = form && form.querySelector('[name="id"]');
        return selector && selector.value;
      }

      function getYampiUrl() {
        return fetch('/cart.json', { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('cart-read-failed');
            return response.json();
          })
          .then(function (cartPayload) {
            return fetch('https://api.dooki.com.br/v2/public/shopify/cart', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                shop: window.location.host,
                shopify_internal_domain: (window.Shopify && Shopify.shop) || window.location.host,
                cart_payload: cartPayload
              })
            });
          })
          .then(function (response) {
            if (!response.ok) throw new Error('yampi-url-failed');
            return response.json();
          })
          .then(function (data) {
            if (!data || !data.checkout_direct_url) throw new Error('missing-yampi-url');

            if (typeof window.ymp_getUrlWithUtms === 'function') {
              return window.ymp_getUrlWithUtms(data.checkout_direct_url);
            }

            return data.checkout_direct_url;
          });
      }

      function directCheckout() {
        var variantId = currentVariantId();

        if (!variantId || buy.disabled) return;

        quantity(input.value);
        buy.disabled = true;
        buy.classList.add('is-loading');

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: Math.max(1, parseInt(input.value, 10) || 1)
          })
        }).then(function (response) {
          if (!response.ok) throw new Error('sticky-checkout-add-failed');
          return getYampiUrl();
        }).then(function (checkoutUrl) {
          window.location.href = checkoutUrl;
        }).catch(function () {
          buy.disabled = false;
          buy.classList.remove('is-loading');
          window.location.href = '/checkout';
        });
      }

      function visible(show) {
        if (isVisible === show) return;
        isVisible = show;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('has-product-sticky-buy', show);
      }

      function isPastPurchase() {
        return purchase ? purchase.getBoundingClientRect().bottom < 0 : window.scrollY > 700;
      }

      function isAfterScrollLimit() {
        var scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
        return (window.scrollY / scrollable) >= 0.80;
      }

      function updateByScroll() {
        var currentY = window.scrollY;
        var delta = currentY - lastY;
        var direction = delta > 1 ? 'down' : delta < -1 ? 'up' : lastDirection;

        if (!isPastPurchase() || isAfterScrollLimit()) {
          visible(false);
          directionStartY = currentY;
        } else if (mobileQuery.matches) {
          if (direction && direction !== lastDirection) directionStartY = currentY;
          var distance = Math.abs(currentY - directionStartY);

          if (direction === 'up' && distance >= 24) visible(false);
          if (direction === 'down' && distance >= 24) visible(true);
        } else {
          visible(true);
        }

        if (direction) lastDirection = direction;
        lastY = currentY;
      }

      bar.addEventListener('click', function (event) {
        var action = event.target.closest('[data-sticky-quantity]');
        if (action) quantity(Number(input.value) + (action.dataset.stickyQuantity === 'plus' ? 1 : -1));

        if (event.target.closest('[data-sticky-buy]')) {
          directCheckout();
        }
      });

      input.addEventListener('change', function () { quantity(input.value); });
      window.addEventListener('scroll', updateByScroll, { passive: true });
      window.addEventListener('resize', updateByScroll);
      if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', updateByScroll);

      document.addEventListener('variant:changed', function (event) {
        var variant = event.detail && event.detail.variant;
        if (!variant) return;
        variantText.textContent = variant.title || '';
        price.textContent = money(variant.price);
        buy.disabled = !variant.available;
        if (product && variant.featured_image) image.src = variant.featured_image.src || variant.featured_image;
      });

      updateByScroll();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
